<template>
  <section>
    <b-row class="px-50">
      <ecommerce-statistics
        :statistics="statistics"
        :loading="loading"
        class="w-100"
      />
      <!-- <b-col cols="12" md="4">
        <ecommerce-earnings-chart :loading="loading" :earning="earning" />
      </b-col> -->
    </b-row>
    <b-row>
      <add-items-row :loading="loading" class="w-100" />
    </b-row>

    <b-row class="d-flex align-items-stretch justify-content-center">
      <div class="col-md-6 col-12 px-50">
        <most-visit-sessions :data="most_visit" />
      </div>

      <div class="col-md-6 col-12 px-50">
        <last-session-seen :data="last_session_seen" />
      </div>

      <div class="col-12 p-50">
        <user-of-courses />
      </div>
      <div class="col-md-8 col-12 p-50">
        <latest-logins />
      </div>
      <div class="col-md-4 col-12 p-50">
        <ecommerce-goal-overview />
      </div>
      <!-- <div class="col-md-6 col-12 p-50">
        <analytics-app-design :data="AnalyticsAppDesign"></analytics-app-design>
      </div> -->

      <!-- <div class="col-md-6 col-12 p-50">
        <analytics-avg-sessions :data="AnalyticsAvgSessions" />
      </div>
      <div class="col-md-6 col-12 p-50">
        <ticket />
      </div> -->
      <div class="col-md-12 col-12 p-50">
        <ecommerce-revenue-report />
      </div>
      <div class="col-md-12 col-12 p-50">
        <user-activity />
      </div>

      <!-- <div class="col-md-6 col-12 p-50">
        <user-ratio :loading="loading" />
      </div> -->
      <!-- <div class="col-md-3 col-12">
        <progress-chart :radialBarChart="radialBarChartCourses" />
      </div>
      <div class="col-md-3 col-12">
        <progress-chart :radialBarChart="radialBarChartTerms" />
      </div> -->

      <div class="col-md-6 col-12 p-50">
        <last-fags />
      </div>
      <div class="col-md-6 col-12 p-50">
        <last-comments />
      </div>
      <div class="col-md-6 col-12 p-50">
        <last-penalties :penaltiesCount="userHasPenalties" />
      </div>
      <div class="col-md-6 col-12 p-50">
        <last-invoices />
      </div>
      <!-- <div class="col-md-6 col-12 p-50">
        <active-users :activeUsers="activeUsers" :loading="loading" />
      </div> -->
    </b-row>

    <modal v-if="!!Notification" :visible="!!Notification" />
  </section>
</template>

<script>
import { BRow, BCol, BButton } from "bootstrap-vue";
import EcommerceStatistics from "./EcommerceStatistics.vue";
import EcommerceEarningsChart from "./EcommerceEarningsChart.vue";
import ActiveUsers from "./ActiveUsers.vue";
import lastFags from "./lastFags.vue";
import lastComments from "./lastComments.vue";
import lastPenalties from "./lastPenalties.vue";
import lastInvoices from "./lastInvoices.vue";
import userOfCourses from "./userOfCourses.vue";
import mostVisitSessions from "./mostVisitSession.vue";
import UserRatio from "./UserRatio.vue";
import lastSessionSeen from "./lastSessionSeen.vue";
import EcommerceRevenueReport from "./EcommerceRevenueReport.vue";
import ProgressChart from "./ProgressChart.vue";
import latestLogins from "./latestLogin.vue";
import Ticket from "./Ticket.vue";
import Modal from "./Modal.vue";
import AnalyticsAppDesign from "./AnalyticsAppDesign.vue";
import EcommerceGoalOverview from "./EcommerceGoalOverview.vue";
import AnalyticsAvgSessions from "./AnalyticsAvgSessions.vue";
import addItemsRow from "./addItemsRow.vue";
import userActivity from "./userActivity.vue";
import qs from "qs";

export default {
  components: {
    mostVisitSessions,
    lastSessionSeen,
    addItemsRow,
    AnalyticsAppDesign,
    BRow,
    BCol,
    EcommerceStatistics,
    EcommerceEarningsChart,
    EcommerceRevenueReport,
    ProgressChart,
    ActiveUsers,
    UserRatio,
    Ticket,
    Modal,
    BButton,
    EcommerceGoalOverview,
    AnalyticsAvgSessions,
    lastFags,
    lastComments,
    lastPenalties,
    lastInvoices,
    userOfCourses,
    latestLogins,
    userActivity,
  },
  data() {
    return {
      loading: false,

      statistics: [],
      activeUsers: [],
      AnalyticsAppDesign: {
        date: "03 Sep, 20",
        title: "App design",
        subtitle:
          "You can Find Only Post and Quotes Related to IOS like ipad app design, iphone app design",
        teams: [
          { name: "Figma", color: "light-warning" },
          { name: "Wireframe", color: "light-primary" },
        ],
        members: [
          { img: "/img/avatar-s-9.397f0acd.jpg", color: "primary" },
          { text: "PI", color: "light-danger" },
          { img: "/img/avatar-s-14.93df8c5c.jpg", color: "primary" },
          { img: "/img/avatar-s-7.cb1b1e65.jpg", color: "primary" },
          { text: "AL", color: "light-secondary" },
        ],
        planing: [
          { title: "Due Date", subtitle: "12 Apr, 21" },
          { title: "Budget", subtitle: "$49251.91" },
          { title: "Cost", subtitle: "$840.99" },
        ],
      },

      radialBarChartCourses: {},
      radialBarChartTerms: {},
      earning: {},
      userHasPenalties: 0,
      most_visit: {},
      last_session_seen: {},
      progressCourse: {},
    };
  },
  computed: {
    Notification() {
      return this.$store.state.appConfig.count;
    },
  },
  methods: {
    async getDashboradStatistics() {
      try {
        const { data } = await this.$http.get("/panel/dashboard/statistics");
        this.userHasPenalties = data.data.user_has_penalties;
        this.most_visit = data.data.most_visit;
        this.last_session_seen = data.data.last_session_seen;
      } catch (err) {}
    },
    async getDashboard() {
      try {
        const { data } = await this.$http.get("/panel/dashboard");
        this.statistics = await [
          {
            title: "تعداد کاربران",
            text:
              data.data.counts && data.data.counts.users
                ? `${this.numberWithCommas(data.data.counts.users)}`
                : "-",
            icon: "UsersIcon",
            color: "primary",
          },
          {
            title: "تعداد دوره ها",
            text:
              data.data.counts && data.data.counts.courses
                ? `${this.numberWithCommas(data.data.counts.courses)}`
                : "-",
            icon: "ClipboardIcon",
            color: "danger",
          },
          {
            title: "تعداد ترم های فعال",
            text:
              data.data.counts && data.data.counts.active_semesters
                ? `${this.numberWithCommas(data.data.counts.active_semesters)}`
                : "-",
            icon: "TrelloIcon",
            color: "success",
          },
          {
            title: "درآمد",
            text:
              data.data.counts && data.data.counts.total_income
                ? `${this.numberWithCommas(
                    data.data.counts.total_income
                  )} تومان`
                : "-",
            icon: "DollarSignIcon",
            color: "info",
          },
        ];
        await this.calRateInCourses(data.data.charts.rate_in_courses);
      } catch (err) {}
    },

    calRateInCourses(items) {
      let count = 0;
      items.forEach((item) => {
        item.participatedPercent = item.students
          ? Math.ceil((item.participated / item.students) * 100)
          : 0;
        count += item.participatedPercent;
      });
      this.earning.rateInCourses = items;
      this.earning.total = {
        count: Math.ceil(count / items.length),
        TotalParticipated: this.statistics[0].text,
      };
    },
  },
  async created() {
    this.loading = true;
    await this.getDashboard();
    await this.getDashboradStatistics();
    this.loading = false;
    // this.activeUsers = [
    //   {
    //     id: 1,
    //     fullName: "soroush basirat pour",
    //     courses: [
    //       { id: 1, name: "دوره ۱" },
    //       { id: 2, name: "دوره 2" },
    //       { id: 3, name: "دوره 3" },
    //     ],
    //     penalties: [
    //       { id: 1, name: "جریمه ۱" },
    //       { id: 2, name: "جریمه 2" },
    //       { id: 3, name: "جریمه 3" },
    //     ],
    //     correctAnswers_count: 5,
    //     progressPercentage: 45,
    //   },
    //   {
    //     id: 2,
    //     fullName: "soroush basirat pour",
    //     courses: [
    //       { id: 1, name: "دوره ۱" },
    //       { id: 2, name: "دوره 2" },
    //       { id: 3, name: "دوره 3" },
    //     ],
    //     penalties: [
    //       { id: 1, name: "جریمه ۱" },
    //       { id: 2, name: "جریمه 2" },
    //       { id: 3, name: "جریمه 3" },
    //     ],
    //     correctAnswers_count: 5,
    //     progressPercentage: 45,
    //   },
    //   {
    //     id: 3,
    //     fullName: "soroush basirat pour",
    //     courses: [
    //       { id: 1, name: "دوره ۱" },
    //       { id: 2, name: "دوره 2" },
    //       { id: 3, name: "دوره 3" },
    //     ],
    //     penalties: [
    //       { id: 1, name: "جریمه ۱" },
    //       { id: 2, name: "جریمه 2" },
    //       { id: 3, name: "جریمه 3" },
    //     ],
    //     correctAnswers_count: 5,
    //     progressPercentage: 45,
    //   },
    //   {
    //     id: 4,
    //     fullName: "soroush basirat pour",
    //     courses: [
    //       { id: 1, name: "دوره ۱" },
    //       { id: 2, name: "دوره 2" },
    //       { id: 3, name: "دوره 3" },
    //     ],
    //     penalties: [
    //       { id: 1, name: "جریمه ۱" },
    //       { id: 2, name: "جریمه 2" },
    //       { id: 3, name: "جریمه 3" },
    //     ],
    //     correctAnswers_count: 5,
    //     progressPercentage: 45,
    //   },
    // ];
    // this.radialBarChartCourses = {
    //   title: "درصد پیشرفت دوره ها",
    //   series: [80, 50, 35],
    //   chartOptions: {
    //     plotOptions: {
    //       radialBar: {
    //         size: 185,
    //         hollow: {
    //           size: "10%",
    //         },
    //         track: {
    //           margin: 15,
    //         },
    //         dataLabels: {},
    //       },
    //     },
    //     legend: {
    //       show: true,
    //       position: "bottom",
    //       horizontalAlign: "center",
    //     },
    //     stroke: {
    //       lineCap: "round",
    //     },
    //     labels: [" دوره ۱ ", " دوره ۲ ", " دوره ۳ "],
    //   },
    // };
    // this.radialBarChartTerms = {
    //   title: "درصد پیشرفت ترم ها",
    //   series: [80, 50, 35],
    //   chartOptions: {
    //     plotOptions: {
    //       radialBar: {
    //         size: 185,
    //         hollow: {
    //           size: "10%",
    //         },
    //         track: {
    //           margin: 15,
    //         },
    //         dataLabels: {},
    //       },
    //     },
    //     legend: {
    //       show: true,
    //       position: "bottom",
    //       horizontalAlign: "center",
    //     },
    //     stroke: {
    //       lineCap: "round",
    //     },
    //     labels: [" ترم ۱ ", " ترم ۲ ", " ترم ۳ "],
    //   },
    // };
  },
};
</script>
